import styled from "styled-components/macro";
import React, { useEffect, useState } from "react";
import {
  MdArrowBackIosNew,
  MdArrowForwardIos,
  MdBookmark,
  MdBookmarkBorder,
  MdMenu,
  MdMonetizationOn,
  MdOutlineMonetizationOn,
  MdOutlineShoppingCart,
  MdOutlineVideocam,
  MdPerson,
  MdPersonOutline,
  MdPlayArrow,
  MdPlayCircle,
  MdPlayCircleOutline,
  MdShoppingCart,
} from "react-icons/md";

import "../styles/Home.css";
import { isEmpty } from "../functions/isEmpty";
import { getEuroCentToEuro } from "../functions/getEuroCentToEuro";
import { useLocation, useNavigate } from "react-router";
import VideoRecorder from "../components/VideoRecorder";
import URLPreloadFromArray from "../components/URLPreloadFromArray";
import Bottombar from "../components/Bottombar";

export default function Home({
  isMobile,
  apiURL,
  authToken,
  creators,
  services,
  categories,
  filteredBusiness,
  setFilteredBusiness,
  searchInput,
  setSearchInput,
  destroySession,
  companyData,
  scrollPositionHome,
  setScrollPositionHome,
  becomeSellerActive,
  isSeller,
  setIsSeller,
}) {
  let navigate = useNavigate();
  let location = useLocation().pathname;
  const [openBusinessFilter, setOpenBusinessFilter] = useState(false);
  const [preloadVideos, setPreloadVideos] = useState([]);

  // Function to save the current scroll position
  const handleNavigateClick = (destination) => {
    setScrollPositionHome(window.scrollY);
    window.scrollTo(0, 0);

    navigate(destination);
  };

  // Effect to scroll to the saved position on component mount
  useEffect(() => {
    window.scrollTo(0, scrollPositionHome);
  }, [scrollPositionHome]);

  const isWordInArray = (wordArrayString, searchWord) => {
    try {
      // Parse the string into an array
      const wordArray = JSON.parse(wordArrayString);

      // Check if the word exists in the array
      return wordArray.includes(searchWord);
    } catch (error) {
      console.error("Invalid input format:", error);
      return false;
    }
  };

  const isSubstring = (substring, mainString) => {
    if (!substring || !mainString) return false; // Handle empty or null inputs
    return mainString.toLowerCase().includes(substring.toLowerCase());
  };

  const removeFilter = () => {
    setSearchInput("");
    setFilteredBusiness("");
    setOpenBusinessFilter(false);
  };

  const pickFilter = (businessstring) => {
    setFilteredBusiness(businessstring);
    setOpenBusinessFilter(false);
  };

  const filterArrayByTitle = (array, searchString) => {
    return array.filter(
      (item) => item && isSubstring(searchString, item.category_id)
    );
  };

  useEffect(() => {
    if (!isEmpty(services)) {
      let helpArr = [];
      services.map((service) => {
        helpArr.push(service.video_url);
      });

      setPreloadVideos(helpArr);
    }
  }, [services]);

  useEffect(async () => {
    if (!isEmpty(authToken) && becomeSellerActive) {
      navigate("/sellerprofile");
    }
  }, [companyData, becomeSellerActive, authToken]);

  return (
    <div>
      {!isMobile && <URLPreloadFromArray mediaURLArray={preloadVideos} />}

      {openBusinessFilter ? (
        <div className="homebusinessfilter">
          <div className="homebusinessfilter_topnav">
            <div
              className="homebusinessfilter_topnav_back"
              onClick={() => setOpenBusinessFilter(false)}>
              <ArrowBack />
            </div>
            <div className="homebusinessfilter_topnavSearchfield">
              <input
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                placeholder="Nach Beruf suchen"
                className="homebusinessfilter_topnavSearchfield_input"
              />
            </div>
            <div
              className="homebusinessfilter_resetFilter"
              onClick={() => removeFilter()}>
              Filter löschen
            </div>
          </div>
          <div className="homebusinessfilter_body">
            {categories.map((category) => (
              <>
                {isEmpty(searchInput) ? (
                  <div
                    className="homebusinessfilter_body_listelelement"
                    onClick={() => pickFilter(category)}>
                    {category}
                  </div>
                ) : (
                  <>
                    {isSubstring(searchInput, category) && (
                      <div
                        className="homebusinessfilter_body_listelelement"
                        onClick={() => pickFilter(category)}>
                        {category}
                      </div>
                    )}
                  </>
                )}
              </>
            ))}
          </div>
        </div>
      ) : (
        <div className="home">
          {isMobile ? (
            <div className="home_topnav">
              <div className="home_topnav_logo">
                <div className="home_topnav_logo_icon">
                  <PlayIconOrange /> <PlayIconOrange />
                </div>
                <div className="home_topnav_logo_text"> doodli </div>
              </div>
              <div className="home_topnav_left">
                <div className="home_topnav_left_searchbarbox">
                  <input
                    type="text"
                    className="home_topnav_left_searchbarbox_input"
                    placeholder="Werbung suchen"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
              </div>
              <div className="home_topnav_right">
                {isEmpty(authToken) ? (
                  <div
                    className="home_topnav_right_button"
                    onClick={() => handleNavigateClick("/login")}>
                    <MenuIcon /> Login
                  </div>
                ) : (
                  <>
                    {!isEmpty(companyData) && companyData.isACreator == 0 ? (
                      <div
                        className="home_topnav_right_button"
                        onClick={() => handleNavigateClick("/menu")}>
                        <MenuIcon /> Menu
                      </div>
                    ) : (
                      <div
                        className="home_topnav_right_button"
                        onClick={() => handleNavigateClick("/sellerprofile")}>
                        <PersonIcon />{" "}
                        {!isEmpty(companyData) &&
                          companyData.instagramProfileURL}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          ) : (
            <div className="home_topnav">
              <div className="home_topnav_left">
                <div className="home_topnav_left_searchbox">
                  <input
                    type="text"
                    placeholder="Suchen"
                    className="home_topnav_left_searchbox_input"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>
              </div>{" "}
              <div className="home_topnav_right">
                {isEmpty(authToken) ? (
                  <div
                    className="home_topnav_right_account button"
                    onClick={() => handleNavigateClick("/login")}>
                    Login
                  </div>
                ) : (
                  <>
                    {!isEmpty(companyData) && companyData.isACreator == 0 ? (
                      <div
                        className="home_topnav_right_account button"
                        onClick={() => handleNavigateClick("/menu")}>
                        Menu
                      </div>
                    ) : (
                      <div
                        className="home_topnav_right_account button"
                        onClick={() => handleNavigateClick("/sellerprofile")}>
                        {" "}
                        {!isEmpty(companyData) &&
                          companyData.instagramProfileURL}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          )}

          <div className="home_body">
            <div className="home_body_filteredList">
              {services.map((service) => (
                <div
                  className="home_body_filteredList_listelement button"
                  onClick={() => handleNavigateClick("/product/" + service.id)}>
                  <div className="home_body_filteredList_listelement_top">
                    <img
                      src={service.preview_img_url}
                      className="home_body_filteredList_listelement_top_img"
                    />
                  </div>
                  <div className="home_body_filteredList_listelement_bottom">
                    <div className="home_body_filteredList_listelement_bottom_left">
                      {service.title}
                    </div>
                    <div className="home_body_filteredList_listelement_bottom_right">
                      {" "}
                      {getEuroCentToEuro(service.company_price)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const MenuIcon = styled(MdMenu)`
  font-size: 30px;
  color: #474747;
`;

const ArrowForwardIcon = styled(MdArrowForwardIos)`
  font-size: 18px;
  color: #474747;
`;

const PersonIcon = styled(MdPersonOutline)`
  font-size: 30px;
  color: #474747;
`;

const ArrowBack = styled(MdArrowBackIosNew)`
  font-size: 23px;
  color: #474747;
`;

const PlayIcon = styled(MdPlayCircleOutline)`
  font-size: 30px;
  color: #474747;
`;

const PlayIconOrange = styled(MdPlayArrow)`
  font-size: 30px;
  margin-right: -16px;
  color: #f58700;
`;

const MoneyIcon = styled(MdOutlineMonetizationOn)`
  font-size: 30px;
  color: #474747;
`;

const VideocamIcon = styled(MdOutlineVideocam)`
  font-size: 30px;
  color: #474747;
`;
